import React from "react";

const Tag = ({ tagText, tagBg, tagColor, tagPosition }) => {
  let positionStyle;
  switch (tagPosition.join(", ")) {
    case "top, left":
      positionStyle = { top: 10, left: 10 };
      break;
    case "top, right":
      positionStyle = { top: 10, right: 10 };
      break;
    case "bottom, left":
      positionStyle = { bottom: 10, left: 10 };
      break;
    case "bottom, right":
      positionStyle = { bottom: 10, right: 10 };
      break;

    case "center, right":
      positionStyle = { top: "50%", right: 10, transform: "translate( 0%,-50%)" };
      break;

    case "center, left":
      positionStyle = { top: "50%", left: 10, transform: "translate( 0%,-50%)" };
      break;

    case "center, center":
      positionStyle = { top: "50%", left: "50%", transform: "translate( -50%,-50%)" };
      break;

    default:
      positionStyle = { top: 10, right: 10 };
  }

  const tagStyle = {
    borderRadius: 100,
    zIndex: 30,
    position: "absolute",
    backgroundColor: tagBg,
    color: tagColor,
    fontSize: 12,
    minWidth: 60,
    padding: 4,
    fontWeight: "bold",
    border: `1px solid ${tagColor}`,
    // Spread the positioning style of the tag here
    ...positionStyle,
  };

  return <div style={tagStyle}>{tagText}</div>;
};

export default Tag;
